// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"accountSummary_wrapper__3SsXr"};